import { useParams } from 'react-router-dom';
import { TeacherModuleAttendanceView } from '@/views/TeacherModuleAttendanceView';
import { MainLayout } from '@/widgets/layouts/MainLayout';

const AttendancePage = () => {
  const { courseId, intakeId, groupNumber, termId, moduleId } = useParams<{
    courseId: string;
    intakeId: string;
    groupNumber: string;
    termId: string;
    moduleId: string;
  }>();

  if (!courseId || !intakeId || !groupNumber || !termId || !moduleId) {
    return null;
  }

  return (
    <MainLayout headerTitle="Attendance">
      <TeacherModuleAttendanceView />
    </MainLayout>
  );
};

export default AttendancePage;

